import { Authority } from '@/models/permission/AuthorityModel.ts';

export const toDisplayName = (authority: Authority, exists: boolean) =>
  authority.type === 'group' && !exists ? authority.id.split('_').slice(3).join(' ') : authority.name;

export const handleDeletedAuthorities = (authorities: any, roomMembers: any) =>
  authorities?.map((authority: any) => {
    if (!roomMembers?.length) {
      return authority;
    }

    const exists = !!roomMembers?.find((rm: any) => rm.id === authority.id);

    return { ...authority, name: toDisplayName(authority, exists), deleted: !exists };
  });
